<template>
  <div class="order-item">
    <div class="main_header">
      <div class="main_header_l">
        {{ calcTime(item.createAt) }}
      </div>
      <div class="main_header_r" :class="{ cancel: item.status === 'cancel' }">
        {{ calcStatus(item.status) }}
      </div>
    </div>
    <!-- 订单商品详情 -->
    <!-- 商品列表 -->
    <template v-if="item.orderGoods && item.orderGoods.length">
      <goods-list :goods-list="item.orderGoods" />
    </template>
    <!-- 商品统计 -->
    <div class="main_total">
      <div class="total_left">共{{ calcTotalCount(item.orderGoods) || 0 }} 件商品</div>
      <div class="total_right">合计:{{ totalPrice(item) }}</div>
    </div>
    <!-- 操作按钮 -->
    <div class="main_btn" style="padding-bottom: 0">
      <div class="main_btn_def" @click="() => emits('detail', item.id)">订单详情</div>
      <div
        class="main_btn_def cancel"
        v-if="['wait_pay'].includes(item.status)"
        @click="() => emits('cancel', item.id)"
      >
        取消订单
      </div>
      <div
        class="main_btn_def active"
        v-if="item.status == 'wait_pay'"
        @click="() => emits('pay', item)"
      >
        支付
      </div>
      <div
        class="main_btn_def del"
        v-if="item.status == 'cancel'"
        @click="() => emits('delete', item.id)"
      >
        删除订单
      </div>
      <div
        class="main_btn_def"
        v-if="['partial_delivery', 'wait_receive', 'wait_pickup'].includes(item.status)"
        @click="() => emits('logistics', item.id)"
      >
        查看物流
      </div>
      <div
        class="main_btn_def outline"
        v-if="['partial_delivery', 'wait_receive'].includes(item.status)"
        @click="() => emits('confirm', item.id)"
      >
        确认收货
      </div>
      <div
        class="main_btn_def outline"
        v-if="item.status == 'wait_comment'"
        @click="() => emits('evaluate', item.id)"
      >
        评价订单
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue'
  import GoodsList from './GoodsList.vue'
  import { orderStatusMap } from '@/enums/statusEnum'
  import { calcTime } from '@/utils'

  defineProps({
    item: {
      type: Object,
      required: true
    }
  })
  const emits = defineEmits([
    'detail',
    'pay',
    'cancel',
    'delete',
    'confirm',
    'logistics',
    'evaluate'
  ])

  const calcStatus = status => orderStatusMap[status]

  const calcTotalCount = goodsList => goodsList.reduce((calc, val) => val.num + calc, 0) ?? 0

  const totalPrice = item => {
    if (!item.points) return '￥' + item.amount
    if (!item.amount) return item?.points + '积分'
    return `${item.points}积分 + ￥${item.amount}`
  }
</script>

<style lang="scss" scoped>
  .order-item {
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 12px;
    background-color: #fff;

    .main_header {
      font-size: 14px;
      color: #101010;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f2f3f5;
      padding-bottom: 10px;

      .main_header_r {
        color: #9b0f02;
        &.cancel {
          color: #fc6e1f;
        }
      }
    }

    .pickInfo {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333;
      height: 80px;
      border-bottom: 1px solid #e8e8e8;

      .address {
        flex: 1;
        width: 1px;
        margin: 0 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .btns {
        display: flex;
        gap: 15px;
      }
    }

    /* 商品统计部分 */
    .main_total {
      font-size: 14px;
      color: #101010;
      height: 80px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      border-bottom: 1px solid #f2f3f5;

      .total_left {
        margin-right: 16px;
      }
    }

    /* 按钮 */
    .main_btn {
      width: 100%;
      height: auto;
      padding: 10px 0 10px 10px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 12px;
      color: #101010;

      .main_btn_def {
        min-width: 60px;
        padding: 4px 10px;
        margin-right: 8px;
        border: 1px solid #bbbbbb;
        border-radius: 25px;
        text-align: center;
        cursor: pointer;

        &.del {
          margin-right: 8px;
          background: #dc181a;
          color: #ffffff;
          border: 1px solid #dc181a;
        }

        &.outline {
          border-color: #fc5a01;
          color: #fc5a01;
        }

        &.active {
          color: #fff;
          background: #ff9f3e;
          border-color: #ff9f3e;
        }

        &.cancel {
          background: #e6e6e6;
          border-color: #e6e6e6;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .shareBtn {
        border: 1px solid #ddd;
        background-color: #ffffff;
        padding: 0 10px;
        font-size: 12px;
        color: #666666;

        &::after {
          border: 0;
        }
      }
    }
  }
</style>
